import { useMemo } from 'react';

import { useInfiniteQuery } from '@tanstack/react-query';

import { getPagesContent } from '@pkg/hooks';

import { callGetFantasyWishlists } from '@app/client/resources/wishlists';
export const ACTIVE_LINEUPS_CACHE = 'active-lineups-cache';
export const useGetUserFantasyWishlists = (disabled?: boolean) => {
    const cache = [ACTIVE_LINEUPS_CACHE];

    const res = useInfiniteQuery(
        cache,
        ({ pageParam = 0, signal }) =>
            callGetFantasyWishlists({
                settings: { signal },
                query: {
                    page: pageParam,
                    limit: 30,
                },
            }),
        {
            retry: false,
            keepPreviousData: true,
            enabled: !disabled,
        },
    );

    return useMemo(() => getPagesContent(res.data?.pages), [res.data?.pages]);
};
